import React from "react";
import {
  FaMoneyBillWave,
  FaGlobeAmericas,
  FaCreditCard,
  FaUserCheck,
  FaShieldAlt,
  FaHeadset,
  FaMapMarkerAlt,
  FaWhatsapp,
  FaTelegram,
} from "react-icons/fa";

const GogoCabFeatures = () => {
  const features = [
    {
      icon: <FaMoneyBillWave className="text-green-500 text-xl" />,
      title: "Affordable Pricing",
      desc: "Clear, no-hidden-fee pricing.",
    },
    {
      icon: <FaGlobeAmericas className="text-blue-500 text-xl" />,
      title: "International Support",
      desc: "WhatsApp / Telegram available",
      subIcon: (
        <div className="flex mt-1">
          <FaWhatsapp className="text-green-600 mr-2 text-sm" />
          <FaTelegram className="text-blue-400 text-sm" />
        </div>
      ),
    },
    {
      icon: <FaCreditCard className="text-purple-500 text-xl" />,
      title: "Multiple Payments",
      desc: "UPI, Cash, Card, online etc",
    },
    {
      icon: <FaUserCheck className="text-yellow-500 text-xl" />,
      title: "Trusted Drivers",
      desc: "Experienced drivers",
    },
    {
      icon: <FaShieldAlt className="text-red-400 text-xl" />,
      title: "Safety & Comfort",
      desc: "Your safety comes first",
    },
    {
      icon: <FaHeadset className="text-indigo-500 text-xl" />,
      title: "24/7 Support",
      desc: "Always here to help",
    },
    // {
    //   icon: <FaMapMarkerAlt className="text-teal-500 text-xl" />,
    //   title: "Flexible Locations",
    //   desc: "Multiple pickup/drop points",
    // },
  ];

  return (
    <div className="min-h-fit bg-gradient-to-br from-cyan-50 to-white py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        {/* Header - More compact */}
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-3">
            Features of <span className="text-blue-700">Urbania Nava Cabs</span>
          </h1>
          <p className="text-lg text-gray-600">
            Everything you need for a comfortable ride
          </p>
        </div>

        {/* Features Grid - More compact spacing */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-md p-5 hover:shadow-lg transition-shadow duration-200 border border-gray-100 hover:border-blue-100"
            >
              <div className="flex items-start">
                <div className="flex-shrink-0 mr-4 mt-1">{feature.icon}</div>
                <div className="flex-1">
                  <h3 className="text-base font-semibold text-gray-800 mb-1">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600 text-sm">{feature.desc}</p>
                  {feature.subIcon && <div className="mt-1">{feature.subIcon}</div>}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Footer note - Smaller */}
        <div className="text-center mt-10 text-gray-500 text-sm">
          <p>Your reliable ride, anytime, anywhere.</p>
        </div>
      </div>
    </div>
  );
};

export default GogoCabFeatures;